const basePath = '/admin';

export const adminRoutes = {
  root: basePath,
  organizations: `${basePath}/organizations`,
  organizationDetails: `${basePath}/organizations/:organizationId`,
  users: `${basePath}/users`,
  userDetails: `${basePath}/users/:userId`,
  ai: `${basePath}/ai`,
  aiAgents: `${basePath}/ai/agents`,
  aiAgentDetail: `${basePath}/ai/agents/:id`,
  aiAgentNew: `${basePath}/ai/agents/new`,
  aiUsage: `${basePath}/ai/usage`,
  aiUsageOrganizationDetail: `${basePath}/ai/usage/:organizationId`,
} as const;
